/**
 * Maps the current route to sidebar nav item ids (item1, item70, …).
 * Single source of truth from React Router — no Redux.
 */
export function getSidebarActiveNavId(pathname, search) {
  const path = (pathname || "").replace(/\/$/, "") || "/";
  const params = new URLSearchParams(search || "");

  if (path === "/dashboard") return "item1";
  if (path === "/knowledge-base" || path.startsWith("/knowledge-base/")) return "item137";
  if (path === "/my-todos") return "item138";
  if (path === "/clerk-dashboard") return "item117";
  if (path === "/faculty-dashboard") return "item70";
  if (path === "/faculty/view-tasks") return "item103";
  if (path === "/super-admins-dashboard") return "item9";
  if (path === "/super-admin/billing" || path.startsWith("/super-admin/billing/"))
    return "item97";
  if (path === "/super-admin/hr-payroll") return "item107";
  if (path === "/super-admin/sidebar-layout") return "item109";
  if (path === "/super-admin/role-permissions") return "item120";
  if (path === "/super-admin/vendor-organizations") return "item134";
  if (path === "/vendor/dashboard") return "item135";
  if (path === "/vendor/staff") return "item136";
  if (path === "/demo-requests") return "item108";
  if (path === "/all-schools") return "item124";
  if (path === "/staff-dashboard") return "item22";
  if (path === "/support-lead/tickets") return "item96";
  if (path.startsWith("/ticket-info")) return "item91";

  if (path.startsWith("/luxehara/luxehara-dashboard")) return "item71";
  if (path.startsWith("/luxehara/add-orders")) return "item51";
  if (path.startsWith("/luxehara/all-orders")) return "item61";

  if (path === "/register-thrillion-staff") return "item25";
  if (path === "/view-thrillion-staff" || path.startsWith("/thrillion-staff-profile/")) return "item28";
  if (path === "/manage-schools") return "item50";
  if (path === "/super-admin/school-plans" || path === "/manage-subscription-plans") return "item95";
  if (path === "/super-admin/add-blogs") return "item131";
  if (path === "/super-admin/add-news-articles") return "item132";

  if (path === "/register-school-admins") return "item23";
  if (path === "/view-all-school-admins") return "item24";
  if (path === "/onboard") return "item20";

  if (path === "/diary-info") return "item11";
  if (path === "/view-teaching-plans") return "item105";
  if (path === "/create-class-time-table") return "item118";
  if (path === "/view-class-time-table") return "item119";

  if (path === "/add-student") return "item2";
  if (path === "/view-all-students" || path === "/view-student-profile") return "item5";
  if (path === "/alumni") return "item114";
  if (path.startsWith("/student-promotion")) return "item113";
  if (path === "/edit-student" || path.startsWith("/edit-student/")) return "item4";

  if (path === "/add-faculty") return "item3";
  if (path === "/view-all-faculty" || path.startsWith("/view-all-faculty/")) return "item12";

  if (path === "/calendar") return "item17";
  if (path === "/daily-updates") return "item110";
  if (path === "/announcements") return "item140";

  if (path === "/my-school-settings") return "item133";
  if (path === "/add-classes") return "item32";
  if (path === "/assign-fee") return "item116";
  if (path === "/add-sections") return "item34";
  if (path === "/add-subjects") return "item6";
  if (path === "/add-examinations") return "item8";
  if (path === "/academic-year") return "item10";
  if (path === "/school-info") return "item84";
  if (path === "/app-billing") return "item115";
  if (path === "/school-website") return "item111";
  if (path === "/admissions-enquiry") return "item112";
  if (path === "/school-leave-policy") return "item88";
  if (path === "/school-leave-requests-info") return "item89";
  if (path === "/assign-tasks") return "item90";
  if (path === "/transportation-system") return "item104";
  if (path.startsWith("/school-admin-tickets")) {
    return params.get("tab") === "view" ? "item92" : "item91";
  }

  if (path === "/assign-fees") return "item36";
  if (path === "/fee-details-page") return "item33";
  if (path === "/fee-arrears") return "item139";
  if (path === "/fees-info") return "item106";
  if (path === "/fee-reminders") return "item123";
  if (path === "/collect-fees") return "item37";
  if (path === "/expense-lodger") return "item98";
  if (path === "/employee-payroll") return "item102";

  if (path.startsWith("/add-complaint")) {
    return params.get("tab") === "view" ? "item83" : "item79";
  }

  if (path === "/add-plan") {
    return "item81";
  }
  if (path.startsWith("/action-plan/")) return "item81";

  if (path === "/add-attendance-page") return "item72";
  if (path === "/view-attendance-page") return "item73";
  if (path === "/view-attendance-report") return "item74";
  if (path === "/add-individual-subject-marks") return "item77";
  if (path === "/marks-sheet") return "item80";
  if (path === "/assign-subjects-to-examination") return "item78";

  if (path === "/faculty-leave-details") return "item87";

  if (path === "/faculty/add-diary") return "item99";
  if (path === "/faculty/view-diary") return "item100";
  if (path === "/faculty/add-syllabus-planning") return "item128";
  if (path === "/faculty/view-syllabus-planning") return "item129";
  if (path === "/view-syllabus") return "item130";
  if (path === "/study-material") return "item121";

  return "";
}
